import {
  AnyPartType,
  partTypeAccessory,
  partTypePackage,
  partTypeTire,
  partTypeWheel,
} from "../../../constants/partTypes";
import { useNullableDealerAccountInfo } from "../../../stores/hooks/useNullableDealerAccountInfo";
import { DealerAccountInfoPayload } from "../../../stores/slices/dealerAccountInfoSlice";
import { useOrderDetails } from "../useOrderDetails";

const stripeProductIsEnabled = (
  dealer: DealerAccountInfoPayload,
  partType: AnyPartType
): boolean => {
  switch (partType) {
    case partTypeAccessory:
      return Boolean(dealer?.dealerEnableStripeAccessoryProduct);
    case partTypePackage:
      return Boolean(dealer?.dealerEnableStripePackageProduct);
    case partTypeTire:
      return Boolean(dealer?.dealerEnableStripeTireProduct);
    case partTypeWheel:
      return Boolean(dealer?.dealerEnableStripeWheelProduct);
  }
};

export const useShouldRenderBuyNowButton = (): boolean => {
  const dealer = useNullableDealerAccountInfo();
  const { data: cart } = useOrderDetails();

  return (
    Boolean(dealer?.dealerEnableStripeEcommerce) &&
    Boolean(cart?.orderItemList.length) &&
    Boolean(
      cart?.orderItemList.every((item) => {
        return item.orderEnabled && stripeProductIsEnabled(dealer, item.itemType);
      })
    )
  );
};
